import { render, staticRenderFns } from "./BalaAssignadaMagatzemList.vue?vue&type=template&id=206596e4&scoped=true"
import script from "./BalaAssignadaMagatzemList.vue?vue&type=script&lang=js"
export * from "./BalaAssignadaMagatzemList.vue?vue&type=script&lang=js"
import style0 from "./BalaAssignadaMagatzemList.vue?vue&type=style&index=0&id=206596e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206596e4",
  null
  
)

export default component.exports